// eslint-disable-next-line jira/import-whitelist
import { SYSTEM_DASHBOARD_ID } from '@atlassian/jira-dashboard-common/src/constants.tsx';
import type { RouterContext, RouterDataContext } from '@atlassian/react-resource-router';

export const getKey = ({
	route,
	query,
	match: { params },
}: RouterContext | RouterDataContext): string => {
	if (route.name === 'system-dashboard-edit') {
		return SYSTEM_DASHBOARD_ID;
	}

	if (route.name === 'dashboard-wallboard') {
		// NOTE - Currently we will only load the first dashboard in the list
		return query.dashboardId?.split(',')[0];
	}

	return (
		params.dashboardId?.replace('last-visited', 'lastVisited') ??
		query.selectPageId ??
		'lastVisited'
	);
};
